<section class="process-area bg-top-center space" data-bg-src="assets/img/bg/process_bg_1.jpg">
    <div class="container">
        <div class="process-area">
            <div class="process-content text-center">
                <div class="title-area mb-55">
                    <span class="sub-title style1 text-anime-style-2">Our Work Process</span>
                    <h2 class="sec-title text-anime-style-3">Building Digital Experiences That Inspire and Engage</h2>
                </div>
            </div>
            <div class="slider-area">
                <div class="swiper th-slider has-shadow" id="processSlider"
                    data-slider-options='{"breakpoints":{"0":{"slidesPerView":1},"576":{"slidesPerView":"1"},"768":{"slidesPerView":"2"},"992":{"slidesPerView":"3"},"1200":{"slidesPerView":"3"},"1400":{"slidesPerView":"4"}}}'>
                    <div class="swiper-wrapper">
                        <!--============================== Process Area  ==============================-->
                        <div class="swiper-slide">
                            <div class="process-item wow fadeInUp" data-wow-delay=".2s">
                                <div class="process-img mb-20">
                                    <a routerLink="/planning-and-requirement-gathering">
                                        <img src="assets/img/process/analisis.jpg" alt="Analysis" />
                                    </a>
                                </div>
                                <div class="process-content text-center">
                                    <h3 class="box-title mb-10"><a
                                            routerLink="/planning-and-requirement-gathering">Analysis</a></h3>
                                    <p class="process-text">Planning and requirement gathering for a web application
                                        refer to the process of identifying ...</p>
                                    <p class="box-number">STEP -01</p>
                                </div>
                            </div>
                        </div>

                        <div class="swiper-slide">
                            <div class="process-item wow fadeInUp" data-wow-delay=".4s">
                                <div class="process-img mb-20">
                                    <a routerLink="/design">
                                        <img src="assets/img/process/design.jpg" alt="Design" />
                                    </a>
                                </div>
                                <div class="process-content text-center">
                                    <h3 class="box-title mb-10"><a routerLink="/design">Design</a>
                                    </h3>
                                    <p class="process-text">The design process of web application development involves
                                        creating the visual and interactive...</p>
                                    <p class="box-number">STEP -02</p>
                                </div>
                            </div>
                        </div>

                        <div class="swiper-slide">
                            <div class="process-item wow fadeInUp" data-wow-delay=".6s">
                                <div class="process-img mb-20">
                                    <a routerLink="/website-development">
                                        <img src="assets/img/process/development.jpg" alt="Development" />
                                    </a>
                                </div>
                                <div class="process-content text-center">
                                    <h3 class="box-title mb-10"><a routerLink="/website-development">Development</a></h3>
                                    <p class="process-text">The development process of web application development
                                        involves the implementation and coding of ...</p>
                                    <p class="box-number">STEP -03</p>
                                </div>
                            </div>
                        </div>

                        <div class="swiper-slide">
                            <div class="process-item wow fadeInUp" data-wow-delay=".8s">
                                <div class="process-img mb-20">
                                    <a routerLink="/testing-and-review">
                                        <img src="assets/img/process/testing-and-review.jpg" alt="Testing & Review" />
                                    </a>
                                </div>
                                <div class="process-content text-center">
                                    <h3 class="box-title mb-10"><a routerLink="/testing-and-review">Testing & Review</a>
                                    </h3>
                                    <p class="process-text">The testing process in web application development involves
                                        evaluating the functionality, performance, and ...</p>
                                    <p class="box-number">STEP -04</p>
                                </div>
                            </div>
                        </div>

                        <div class="swiper-slide">
                            <div class="process-item wow">
                                <div class="process-img mb-20">
                                    <a routerLink="/deployment">
                                        <img src="assets/img/process/deployment.jpg" alt="Deployment" />
                                    </a>
                                </div>
                                <div class="process-content text-center">
                                    <h3 class="box-title mb-10"><a routerLink="/deployment">Deployment</a></h3>
                                    <p class="process-text">The deployment process in web application development
                                        involves the steps required to make the application available...
                                    </p>
                                    <p class="box-number">STEP -05</p>
                                </div>
                            </div>
                        </div>

                        <div class="swiper-slide">
                            <div class="process-item wow">
                                <div class="process-img mb-20">
                                    <a routerLink="/maintenance-and-updates">
                                        <img src="assets/img/process/maintenance-and-updates.jpg"
                                            alt="Maintenance and Updates">
                                    </a>
                                </div>
                                <div class="process-content text-center">
                                    <h3 class="box-title mb-10"><a routerLink="/maintenance-and-updates">Maintenance and
                                            Updates</a>
                                    </h3>
                                    <p class="process-text">The maintenance and updates process in web application
                                        development involves managing and enhancing ...</p>
                                    <p class="box-number">STEP -06</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>